Vendd.Scripts.load(function () {
    'use strict';

    var supportedLocales = {
        'en': ['US', 'GB', 'AU', 'AT', 'BE', 'CA', 'CZ', 'DK', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT', 'MX', 'NL', 'NZ', 'NO', 'PL', 'PT', 'RO', 'ES', 'SE', 'CH'],
        'de': ['DE', 'AT', 'CH'],
        'nl': ['NL', 'BE'],
        'fr': ['FR', 'CA', 'CH', 'BE'],
        'cs': ['CZ',],
        'da': ['DK',],
        'fi': ['FI',],
        'sv': ['SE', 'FI'],
        'el': ['GR'],
        'it': ['IT', 'CH'],
        'es': ['ES', 'MX', 'US'],
        'nb': ['NO'],
        'pl': ['PL'],
        'pt': ['PT'],
        'ro': ['RO']
    };

    if (window.klarnaConfig && window.klarnaConfig.IsEnabled) {
        manipulateLanguageCountry();
        manipulateAmount();
        initKlarna();
    }

    function manipulateLanguageCountry() {
        var klarnaPlacement = document.getElementsByTagName('klarna-placement');
   
        if (klarnaPlacement.length < 1) return;

        var html = document.getElementsByTagName('html')[0],
            lang = html.getAttribute('lang') || 'el',
            country = html.getAttribute('country') || 'GR',
            locale = resolveLocale(lang, country);

        for (var i = 0; i < klarnaPlacement.length; i++) {
            klarnaPlacement[i].dataset.locale = locale;
        }
    }

    function manipulateAmount() {
        var klarnaPlacement = document.getElementsByTagName('klarna-placement');

        if (klarnaPlacement.length < 1) return;

        for (var i = 0; i < klarnaPlacement.length; i++) {
            if (klarnaPlacement[i].hasAttribute('data-purchase-amount')) {
                var purchaseAmount = klarnaPlacement[i].dataset.purchaseAmount;

                purchaseAmount = purchaseAmount.split(',');
                purchaseAmount = purchaseAmount[0] + purchaseAmount[1];
                klarnaPlacement[i].dataset.purchaseAmount = purchaseAmount;
            }
        }
    }

    function initKlarna() {
        var script = document.createElement("script");

        script.type = "text/javascript";
        script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
        script.dataset.clientId = window.klarnaConfig.ClientId;
        script.dataset.environment = LhApp.Context.IsProduction ? 'production' : 'playground';
        document.getElementsByTagName('body')[0].appendChild(script);
    }

    function resolveLocale(lang, country) {
        var supportedCountries = supportedLocales[lang];

        if (supportedCountries === undefined) {
            return 'en-US';
        } else if (!supportedCountries.includes(country)) {
            return lang + '-' + supportedCountries[0];
        } else {
            return lang + '-' + country;
        }
    }
});
